import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

export const useLoginButtonVisibility = () => {
  const location = useLocation()
  const [showFigmaButton, setShowFigmaButton] = useState<boolean>(false)
  const [showGoogleButton, setShowGoogleButton] = useState<boolean>(false)
  const [showGithubButton, setShowGithubButton] = useState<boolean>(false)

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const provider = queryParams.get("provider")

    if (!provider) {
      setShowFigmaButton(true)
      setShowGoogleButton(true)
      setShowGithubButton(true)
      return
    }

    if (provider.includes("figma")) setShowFigmaButton(true)
    if (provider.includes("google")) setShowGoogleButton(true)
    if (provider.includes("github")) setShowGithubButton(true)
  }, [location])

  return {
    showFigmaButton,
    showGoogleButton,
    showGithubButton,
  }
}
